import type React from 'react';
import { Col, Layout, Row } from 'antd';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  return (
    <Layout.Footer className={styles.wrapper}>
      <Row align="middle" justify="space-between">
        <Col md={12} span={24}>
          <p className={styles.paragraph}>
            COPYRIGHT ©{new Date().getFullYear()}
            &nbsp; X-Flow, All rights Reserved
          </p>
        </Col>
      </Row>
    </Layout.Footer>
  );
};

export default Footer;
